import React, { useMemo } from "react";
import {
  Card,
  CardContent,
  Typography,
  Button,
  CircularProgress,
  Stack,
} from "@mui/material";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  LabelList,
} from "recharts";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { API_ENDPOINT } from "../../utils/constants";
import useCommonGetInit from "../../hooks/useCommonGetInit";
import { exportToExcel } from "../../utils/util";
import useApiEp from "../../hooks/useApiEp";

const MonthwiseRegistrationsCard = () => {
  const { data: monthwiseData, isLoading: isMonthwiseLoading } = useApiEp(
    `/user/get-monthwise-registrations`
  );

  const dataByMonth = useMemo(() => {
    if (!monthwiseData || !monthwiseData.registrations) return [];

    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    // Transform the data to include year-month label
    const transformedData = monthwiseData.registrations.map((item) => ({
      monthYear: `${monthNames[item.month - 1]} ${item.year}`,
      registrations: item.count,
      year: item.year,
      month: item.month,
      sortKey: item.year * 100 + item.month, // For proper sorting
    }));

    // Sort by year and month
    transformedData.sort((a, b) => a.sortKey - b.sortKey);

    return transformedData;
  }, [monthwiseData]);

  if (isMonthwiseLoading) {
    return (
      <Card>
        <CardContent>
          <Stack
            direction="row"
            justifyContent="center"
            alignItems="center"
            height={250}
          >
            <CircularProgress />
          </Stack>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardContent>
        <Stack direction="row" spacing={2} mb={1}>
          <Typography flex={1} variant="h6">
            Registrations by Month (All Time)
          </Typography>
          <Button
            size="small"
            variant="outlined"
            startIcon={<FileDownloadIcon />}
            onClick={() =>
              exportToExcel(dataByMonth, "All_Registrations_by_Month")
            }
          >
            Export
          </Button>
        </Stack>
        <ResponsiveContainer width="100%" height={250}>
          <BarChart data={dataByMonth}>
            <XAxis
              dataKey="monthYear"
              angle={-45}
              textAnchor="end"
              height={80}
            />
            <YAxis domain={[0, (dataMax) => Math.ceil(dataMax * 1.2)]} />
            <Tooltip />
            <Legend />
            <Bar dataKey="registrations" fill="#8884d8" name="Registrations">
              <LabelList dataKey="registrations" position="top" />
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
};

export default MonthwiseRegistrationsCard;
